import { BlockEditProps } from "@wordpress/blocks";
import React from "react";
import type { BlockAttributes } from "./block.json";
import {
  InspectorControls,
  RichText,
  useBlockProps,
  useInnerBlocksProps,
} from "@wordpress/block-editor";
import ImageEditor from "../../../source/components/ImageEditor";

const ALLOWED_BLOCKS = ["yellowtree/text-slide"];

export default function ColumnEditor(props: BlockEditProps<BlockAttributes>) {
  const blockProps = useBlockProps({
    className: "alignfull",
  });
  const innerBlocksProps = useInnerBlocksProps({
    allowedBlocks: ALLOWED_BLOCKS,
    template: [
      ["yellowtree/text-slide"],
      ["yellowtree/text-slide"],
      ["yellowtree/text-slide"],
    ],
  });
  return (
    <>
      <div {...blockProps}>
        <div className="row me-0 full-2-column">
          <div className="col-xl-6 p-0 position-relative d-flex align-items-center justify-content-center order-1">
            <ImageEditor
              attributes={props.attributes}
              setAttributes={props.setAttributes}
              prefix="image"
              placeholderClassName="img-placeholder"
            />
          </div>
          <div className="col-xl-6 d-flex align-items-center order-2 overflow-hidden">
            <div className="container h-100 overflow-right ms-5">
              <div className="column-swiper">
                <div className="swiper-wrapper">
                  <div {...innerBlocksProps}></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
